<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>编辑角色</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="info">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item
                  prop="companyId"
                  label="所属客户"
                  class="text_left"
                >
                  <el-select
                    v-model="model.companyId"
                    :disabled="disabled"
                    placeholder="请选择..."
                  >
                    <el-option
                      v-for="role in companyList"
                      :key="role.id"
                      :label="role.companyFullName"
                      :value="role.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="角色类型" class="text_left">
                  <el-select
                    v-model="model.roleType"
                    placeholder="请选择..."
                    :disabled="roleType == 2"
                  >
                    <el-option label="系统管理员" :value="1"></el-option>
                    <el-option label="超级管理员" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="name" label="角色标识" v-show="false">
                  <el-input
                    v-model="model.name"
                    placeholder="唯一名称，不可重复"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="title" label="角色名称">
                  <el-input
                    v-model="model.title"
                    placeholder="允许中文,128字符内"
                  ></el-input>
                </el-form-item>
                <el-form-item label="分配权限" v-if="model.roleType === 1">
                  <el-card>
                    <el-tree
                      :data="model.navigation"
                      node-key="id"
                      default-expand-all
                      :expand-on-click-node="false"
                    >
                      <span class="tree-node" slot-scope="{ node, data }">
                        <span>{{ data.title }}</span>
                        <span class="tools-box">
                          <el-checkbox
                            size="mini"
                            v-for="item in data.resources"
                            v-model="item.isSelected"
                            :key="item.name"
                            >{{ item.title }}</el-checkbox
                          >
                        </span>
                      </span>
                    </el-tree>
                  </el-card>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm">确认保存</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      disabled: true,
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式
      companyList: [], //公司列表
      model: {
        gmtCreate: "2022-02-01 16:44:04",
        createdBy: "",
        modifiedBy: "",
        gmtModified: "2022-02-01 16:44:04",
        id: "",
        companyId: "",
        name: "",
        roleType: 1,
        title: "",
        isSystem: 0,
        companyName: "",
        fullCompanyName: "",
        navigation: [],
      },
      roleType: "",
      rules: {
        companyId: [
          { required: true, message: "请选择所属客户", trigger: "change" },
        ],

        name: [
          { required: true, message: "请输入角色标识", trigger: "blur" },
          {
            min: 2,
            max: 128,
            message: "长度在 2 到 128 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[0-9a-zA-Z_]{1,}$/,
            message: "只能字母数字下划线",
            trigger: "blur",
          },
        ],
        title: [{ required: true, message: "请输入角色标题", trigger: "blur" }],
        roleType: [
          { required: true, message: "请选择角色类型", trigger: "change" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      let id = _this.$route.query.id || ""; //获取ID
      if (id > 0) {
        AxiosAjax({
          url: "/cabinet/role/" + id + "?version=2",
          loading: true,
          success: function (res) {
            //赋值给model
            Object.keys(_this.model).forEach((key) => {
              _this.model[key] = res.data.data[key];
            });
            _this.roleType = res.data.data.roleType;
            //console.log(_this.model);
          },
        });
      } else {
        _this.model.name = "F" + Date.parse(new Date());

        _this.model.companyId =
          window.localStorage.getItem("fx_login_companyId");
      }

      // //加载公司列表
      // AxiosAjax({
      //     url: '/cabinet/company/page?index=1&size=9000',
      //     loading: true,
      //     success: function (res) {
      //         //console.log(res.data)
      //         _this.companyList = res.data.data.content
      //     }
      // });

      var companyId = window.localStorage.getItem("fx_login_companyId");
      var companyFullName = window.localStorage.getItem("fx_login_company");
      _this.companyList.push({
        companyFullName: companyFullName,
        id: companyId,
      });

      AxiosAjax({
        url: "/cabinet/role/navigation?version=2",
        loading: true,
        success: function (res) {
          //赋值给model菜单
          _this.model.navigation = res.data.data;
          //console.log(_this.model.navigation);
        },
      });
    },
    submitForm: function () {
      let _this = this; //当前页面
      //多个表单验证
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm1"].validate((valid) => {
          if (valid) resolve();
        });
      });
      Promise.all([f1]).then(() => {
        //提交表单,Id大于0则修改，否则添加
        if (_this.model.id > 0) {
          AxiosAjax({
            method: "put",
            url: "/cabinet/role/update",
            data: _this.model,
            loading: true,
            successMsg: "修改管理角色已成功",
            success: function (res) {
              //可跳转加列表页
              _this.$router.push({ name: "RoleList" });
            },
          });
        } else {
          AxiosAjax({
            method: "post",
            url: "/cabinet/role/save",
            data: _this.model,
            loading: true,
            successMsg: "新增管理角色已成功",
            success: function (res) {
              //重置表单
              //_this.$refs['editForm1'].resetFields();

              //可跳转加列表页
              _this.$router.push({ name: "RoleList" });
            },
          });
        }
      });
    },
    //跳转链接
    linkUrl: function (url) {
      window.location.href = url;
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
.content-box /deep/ .el-tree .el-tree-node__content {
  height: auto;
}
.content-box .el-tree .tree-node {
  align-items: initial;
}
.content-box .el-tree .tools-box {
  position: initial;
  white-space: pre-wrap;
  text-align: right;
}
.text_left /deep/ .el-form-item__content {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Manager/RoleEdit.vue